<template>
    <van-sticky>
        <van-row class="headrow">
            <van-col span="4">

            </van-col>
            <van-col span="16" class="pic">
                <van-image
                        width="80px"
                        fit="contain"
                        :src="logo"
                />
            </van-col>
            <van-col span="4">

            </van-col>
        </van-row>
    </van-sticky>
</template>

<script>
    export default {
        name: "Homehead",
        props:{
            logo:String
        },
        methods:{
            sign(){
                this.$toast("签到");
            }
        }
    }
</script>

<style scoped lang="scss">

    .headrow{
        height: 50px;
        line-height: 50px;
        background: #ED4E39;
        .pic{

            padding: 10px;
            vertical-align:middle;
            img{
                background: #172636;
            }
        }
        .iconfont{
            width: 100%;
            height: 30px;
            border: 1px solid #ff9900;
            padding: 5px;
            border-radius: 5px;
            background: #ff9900;
            color: #333333;
        }
    }
</style>
